export const assignment = {
  input: {
    variables: "Variablen",
    variablesValues: {
      key: "Schlüssel",
      value: "Wert"
    }
  }
};
